import React, { memo } from "react";
import { Dialog, DialogProps } from "@material-ui/core";
import useCreateEventDialog from "./index.hooks";
import { CreateEventForm } from "components";

type CreateEventDialogProps = {} & Omit<DialogProps, "open">;

const CreateEventDialog = ({ ...props }: CreateEventDialogProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    isOpen,
    handleClose,
  } = useCreateEventDialog();

  return (
    <Dialog
      onBackdropClick={handleClose}
      onClose={handleClose}
      open={isOpen}
      {...props}
      classes={classes.dialog}
      maxWidth="md"
      fullWidth
    >
      <CreateEventForm />
    </Dialog>
  );
};

export default memo(CreateEventDialog);
